import type { UserList, User } from 'src/types/User';
import type { PaginatedListResponse } from 'src/api/response_models/PaginatedListIResponse';
import { api } from './api';

export const usersApi = api.injectEndpoints({
  endpoints: builder => ({
    getUsersList: builder.query<
      PaginatedListResponse<UserList>,
      {
        page?: number;
        pageSize?: number;
        searchText?: string;
      }
    >({
      query: ({ page, pageSize, searchText }) => ({
        url: `/auth/list_user/`,
        method: 'GET',
        params: {
          page: page ?? 1,
          page_size: pageSize ?? 100,
          search: searchText,
        },
      }),
    }),
    createUser: builder.mutation<UserList, Partial<UserList>>({
      query: user => ({
        url: `/auth/create_user/`,
        method: 'POST',
        body: user,
      }),
    }),
    updateUser: builder.mutation<User, { user_id: string; data: Partial<UserList> }>({
      query: ({ user_id, data }) => ({
        url: `auth/user/${user_id}/`,
        method: 'PATCH',
        body: data,
      }),
    }),
    deleteUser: builder.mutation<User, { user_id: string }>({
      query: ({ user_id }) => ({
        url: `auth/user/${user_id}/`,
        method: 'DELETE',
      }),
    }),
    sendVerificationEmail: builder.mutation<void, { email: string }>({
      query: ({ email }) => ({
        url: `auth/send-account-verification-email/`,
        method: 'POST',
        body: {
          email,
        },
      }),
    }),
  }),
});

export const {
  useLazyGetUsersListQuery,
  useCreateUserMutation,
  useUpdateUserMutation,
  useDeleteUserMutation,
  useSendVerificationEmailMutation,
} = usersApi;
